module.exports = __webpack_public_path__ + "img/success.78e6d501.svg";